module.exports = __webpack_public_path__ + "img/M_map_5.72954077.png";